import { usePath } from '@arnold/common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TopicGroupTypeCode, UserQuery } from '../../generated/hooks';
import { SortOption, Topics } from '../../components/ConversationSubjects/Topics';

interface IProps {
  user: UserQuery['user'];
}

export const ChooseProcessSurveyScreen: FC<IProps> = ({ user }) => {
  const { t } = useTranslation('surveyGroup');
  const { createProcessSurveyPath } = usePath();
  const { processSurveysPath } = usePath();

  return (
    <Topics
      breadcrumbItems={[{ title: t('processSurveysTitle'), link: processSurveysPath.createPath() }]}
      heading={t('newSurveyGroup')}
      dataIcom="heading-topics"
      user={user}
      hideCategoriesInFilter={true}
      hideCreateTopicButton={true}
      defaultSortOption={SortOption.UPDATED_AT_DESC}
      actionButtonText={t('topicOverview:planTopic')}
      actionButtonOnClick={(tg) => {
        const rootId = tg.parentTopicGroup?.id || tg.id;
        createProcessSurveyPath.toFunc(rootId);
      }}
      filterTopicGroups={(topicGroup) =>
        topicGroup.containsSteps && topicGroup.typeCode !== TopicGroupTypeCode.Onboarding
      }
    />
  );
};
